module.exports = __webpack_public_path__ + "2a4857157c0abf76a8310c2c12e70a55.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/reading-levels/easy.png
// module id = 3410
// module chunks = 0